<template>
  <div class="mb-4 w-full flex flex-col items-start">
    <label v-if="label" :for="name" class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
      {{ label }} <span v-if="required" class="text-red-500">*</span>
    </label>

    <input
      :id="name"
      :name="name"
      :type="type"
      :value="currentValue"
      @input="onInput"
      :placeholder="placeholder"
      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
      :class="{ 'border-red-500': error }"
    />

    <p v-if="error" class="text-red-500 text-xs italic">{{ errorMessage }}</p>
  </div>
</template>

<script>
export default {
  name: "BaseInputText",
  props: {
    value: [String, Number],            // Vue 2 v-model
    modelValue: [String, Number],       // Vue 3 v-model
    label: String,
    placeholder: String,
    name: String,
    type: { type: String, default: "text" },
    required: { type: Boolean, default: false },
    error: Boolean,
    errorMessage: { type: String, default: "Este campo es requerido" },
  },
  computed: {
    // usa modelValue si existe (Vue 3), si no usa value (Vue 2)
    currentValue() {
      return this.modelValue !== undefined ? this.modelValue : this.value;
    },
  },
  methods: {
    onInput(e) {
      const v = e.target.value;
      // emitir ambos: compatibilidad Vue2 y Vue3
      this.$emit("input", v);                  // Vue 2
      this.$emit("update:modelValue", v);     // Vue 3
      this.$emit("input-change", v);          // evento personalizado opcional
    },
  },
};
</script>
